import filter from "lodash/filter";
import flatten from "lodash/flatten";
import map from "lodash/map";

export function getAllChildren(config: {}, rootNode: string): string[] {
  const node = config[rootNode];

  if (node && node.children) {
    const children = flatten(
      map(node.children, (nodeName) => getAllChildren(config, nodeName))
    );

    return filter([rootNode, ...children]);
  }

  return [rootNode];
}
